export enum Layer {
  Default = 1,
  Terrain = 2,
  Water = 3,
  Hostile = 4,
  Neutral = 5,
  Friendly = 6,
  UI = 7
}
